export default "__VITE_ASSET__Bk2Idvkz__"